import { keyBy } from "lodash/fp";

import { FilterChipType } from "@app/analytics/types";

export const FILTER_CHIPS: FilterChipType[] = [
  {
    label: "All Results",
    kind: "all",
    categories: [],
  },
  {
    label: "Action Items",
    kind: "action_item",
    categories: ["action_item"],
  },
  {
    label: "Key Questions",
    kind: "key_question",
    categories: ["key_question"],
  },
  {
    label: "Highlights",
    kind: "highlight",
    categories: [
      "topic",
      "key_question",
      "action_item",
      "language_sentiment",
      "visual_sentiment",
      "visual_engagement",
    ],
  },
  {
    label: "Notepad",
    kind: "note",
    categories: ["note"],
  },
  {
    label: "Summary",
    kind: "summary",
    categories: ["summary"],
  },
  {
    label: "Transcript",
    kind: "turn",
    categories: ["turn"],
  },
  {
    label: "Topics",
    kind: "topic",
    categories: ["topic"],
  },
  {
    label: "Chapters",
    kind: "chapter",
    categories: ["chapter"],
  },
];

export const FILTER_CHIPS_BY_KIND = keyBy("kind", FILTER_CHIPS);
